// src/lib/api.js
const MAIN_ORIGIN = "https://respirarebene.cloud";

export async function apiMe() {
  const r = await fetch(`${MAIN_ORIGIN}/api/me`, {
    credentials: "include",
  });
  return r.json();
}

export async function apiLogin(username, password) {
  const r = await fetch(`${MAIN_ORIGIN}/api/login`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ username, password }),
  });
  const body = await r.json().catch(() => ({}));
  return { ok: r.ok, status: r.status, body };
}

export async function apiLogout() {
  await fetch(`${MAIN_ORIGIN}/api/logout`, {
    method: "POST",
    credentials: "include",
  });
}
